import { render } from "./ScopeSlot.vue?vue&type=template&id=68f044f8"
import script from "./ScopeSlot.vue?vue&type=script&lang=ts"
export * from "./ScopeSlot.vue?vue&type=script&lang=ts"
script.render = render

export default script